import React, { useState } from "react";
import "./TaxFormsPage.css";
import "./TaxFormsPageV2.css";

const TAX_DOCUMENTS = [
  {
    id: "1099-b",
    name: "Form 1099-B",
    description: "Sales of stocks, ETFs, options, and other reportable securities.",
  },
  {
    id: "1099-div",
    name: "Form 1099-DIV",
    description: "Dividends and capital-gain distributions reported by a broker.",
  },
  {
    id: "1099-int",
    name: "Form 1099-INT",
    description: "Reportable interest income from eligible accounts.",
  },
  {
    id: "year-end-summary",
    name: "Year-End Trading Summary",
    description: "A future consolidated summary of realized activity and tax documents.",
  },
];

const TAX_SUMMARY_ITEMS = [
  "Short-Term Gains",
  "Long-Term Gains",
  "Qualified Dividends",
  "Interest Income",
  "Capital Loss Carryover",
  "Wash Sale Adjustments",
];

function TaxFormsPage() {
  const [taxYear, setTaxYear] = useState("2026");

  return (
    <section className="taxFormsPage" aria-labelledby="tax-forms-title">
      <header className="taxFormsHeader">
        <div>
          <span className="taxFormsEyebrow">ANINATRADE TAX CENTER</span>
          <h1 id="tax-forms-title">🧾 Tax Forms</h1>
          <p>
            View future brokerage tax documents and year-end trading summaries in one
            organized workspace.
          </p>
        </div>

        <label className="taxYearSelector" htmlFor="tax-year">
          <span>Tax year</span>
          <select
            id="tax-year"
            value={taxYear}
            onChange={(event) => setTaxYear(event.target.value)}
          >
            <option value="2026">2026</option>
            <option value="2025">2025</option>
            <option value="2024">2024</option>
          </select>
        </label>
      </header>

      <div className="taxFormsSummary taxFormsSummaryExpanded" aria-label="Tax dashboard summary">
        <article><span>Tax year</span><strong>{taxYear}</strong></article>
        <article><span>Realized gains</span><strong>$0.00</strong></article>
        <article><span>Realized losses</span><strong>$0.00</strong></article>
        <article><span>Net capital gain</span><strong>$0.00</strong></article>
        <article><span>Documents</span><strong>0</strong></article>
        <article><span>Broker status</span><strong className="taxStatusPending">Not connected</strong></article>
        <article><span>Estimated tax</span><strong>—</strong></article>
      </div>

      <div className="taxFormsContentGrid">
        <div className="taxFormsMainColumn">
          <section className="taxSummaryPanel" aria-labelledby="tax-summary-title">
            <div className="taxSectionHeading">
              <div>
                <span>TAX DASHBOARD</span>
                <h2 id="tax-summary-title">Tax summary</h2>
              </div>
              <span className="taxYearBadge">{taxYear}</span>
            </div>

            <div className="taxSummaryList">
              {TAX_SUMMARY_ITEMS.map((item) => (
                <div key={item}>
                  <span>{item}</span>
                  <strong>$0.00</strong>
                </div>
              ))}
            </div>
          </section>

          <section className="taxDocumentLibrary" aria-labelledby="tax-library-title">
            <div className="taxSectionHeading">
              <div>
                <span>DOCUMENT LIBRARY</span>
                <h2 id="tax-library-title">Tax documents</h2>
              </div>
              <span className="taxYearBadge">{taxYear}</span>
            </div>

            <div className="taxDocumentList">
              {TAX_DOCUMENTS.map((document) => (
                <article className="taxDocumentCard" key={document.id}>
                  <div className="taxDocumentIcon" aria-hidden="true">▤</div>
                  <div>
                    <h3>{document.name}</h3>
                    <p>{document.description}</p>
                  </div>
                  <span className="taxDocumentStatus">Not available yet</span>
                </article>
              ))}
            </div>
          </section>

          <section className="taxExportPanel" aria-labelledby="tax-export-title">
            <div>
              <span>REPORT EXPORTS</span>
              <h2 id="tax-export-title">Export tax reports</h2>
              <p>Exports remain unavailable until supported tax data has been imported.</p>
            </div>
            <div className="taxExportButtons" aria-label="Unavailable tax export formats">
              <button type="button" disabled>PDF</button>
              <button type="button" disabled>CSV</button>
              <button type="button" disabled>Excel</button>
            </div>
          </section>
        </div>

        <aside className="taxFormsSidebar" aria-label="Tax Forms information">
          <section className="taxEmptyState">
            <span className="taxEmptyIcon" aria-hidden="true">📂</span>
            <h2>No tax documents available</h2>
            <p>
              Tax forms will appear here after supported brokerage connectivity and
              secure document delivery are implemented.
            </p>
          </section>

          <section className="taxInsightsPanel">
            <span>AI TAX INSIGHTS</span>
            <h2>Current tax status</h2>
            <ul>
              <li>No tax documents imported.</li>
              <li>No realized gains detected.</li>
              <li>No wash sales detected.</li>
              <li>Connect a supported broker to organize tax records automatically.</li>
            </ul>
          </section>

          <section className="taxEducationNotice">
            <span>EDUCATIONAL INFORMATION</span>
            <h2>Tax guidance, without pretending to be tax advice</h2>
            <p>
              AninaTrade may eventually explain capital gains, losses, dividends, and
              tax-document terminology. Final filing decisions should be reviewed with
              a qualified tax professional.
            </p>
          </section>
        </aside>
      </div>
    </section>
  );
}

export default TaxFormsPage;
